import React from 'react';
import {
  InstantSearch as ReactInstantSearch,
  InstantSearchProps as ReactInstantSearchProps,
} from 'react-instantsearch-hooks';
import { searchClient } from 'algolia/searchClient';
import InsightsMiddleware from './middlewares/InsightsMiddleware';

const InstantSearch: React.FC<
  Partial<ReactInstantSearchProps & { categorySlug?: string; routing: any; insights: any }>
> = ({ indexName, children, ...props }) => {
  const { categorySlug = '', routing, insights } = props as Record<string, any>;
  return (
    <ReactInstantSearch
      searchClient={searchClient}
      indexName={indexName as string}
      routing={routing}
      insights={insights}
      {...props}
    >
      <InsightsMiddleware categorySlug={categorySlug} />
      {children}
    </ReactInstantSearch>
  );
};

export default InstantSearch;
